import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { bllButton, uiAnchor } from './button.component';
import { UniqueSelectionDispatcher } from '@angular/cdk/collections';

@NgModule({
  imports: [CommonModule],
  declarations: [bllButton, uiAnchor],
  exports: [bllButton, uiAnchor],
  providers: [UniqueSelectionDispatcher],
})
export class BllButtonModule {}
